<template>
  <div class="modal fade" :id="modalId">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <!-- Popup header -->
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">
            <span aria-hidden="true">&times;</span>
            <span class="sr-only">Close</span>
          </button>
          <h4 class="modal-title" id="myModalLabel">Assign client to ad strategist</h4>
        </div>

        <!-- Popup content -->
        <div class="modal-body">
          <!-- Refresh status -->
          <div class="row">
            <div class="col-xs-12">
              <!-- Last update -->
              <span>Last update: {{ updatedOn }}</span>

              <!-- Reload button -->
              <b-button variant="primary" size="sm" @click.stop="getAllClients(true)">
                <i class="fa fa-repeat"></i>
              </b-button>
            </div>
          </div>

          <v-card>
            <v-card-title>
              Clients
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table :headers="fields" :items="items" :search="search">
              <template v-slot:body="{ items }">
                <tbody>
                  <tr v-for="item in items" :key="item.name">
                    <td>{{ item.name }}</td>
                    <td>{{ item.address }}</td>
                    <td>{{ item.website }}</td>
                    <td>{{ item.phoneNumber }}</td>
                    <td>{{ item.name }}</td>
                    <td>
                      <!-- Assign button -->
                      <v-btn
                        color="secondary"
                        small
                        v-if="!isAlreadyAssigned(item)"
                        @click.stop="assignClient(item, true)"
                      >
                        <i class="fa fa-plus"></i>
                      </v-btn>
                      <v-btn
                        color="danger"
                        small
                        v-else
                        @click.stop="assignClient(item, false)"
                      >
                        <i class="fa fa-minus"></i>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
          </v-card>
        </div>

        <!-- Footer -->
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal" ref="closeButton">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import clientAPIs from '../Client/clientAPIs';
// import config from '@/config'
import moment from 'moment';

export default {
  name: 'AssignUserToClientModal',
  props: ['modalId', 'userData'],
  data() {
    return {
      user: null,
      sortBy: 'name',
      sortDesc: false,
      fields: [
        { text: 'name', sortable: true, value: 'name' },
        { text: 'address', sortable: true, value: 'address' },
        { text: 'website', sortable: true, value: 'website' },
        { text: 'phoneNumber', sortable: true, value: 'phoneNumber' },
        { text: 'actions', sortable: false }
      ],
      items: [],
      lastUpdate: null,
      totalRows: 0,
      currentPage: 1,
      perPage: 5,
      search: null,
      filter: null
    };
  },
  watch: {
    userData: function(newUserData) {
      // Update user data
      this.user = newUserData;

      // Retrieve client data
      this.getAllClients(false);
    }
  },
  computed: {
    updatedOn: function() {
      return moment(this.lastUpdate).fromNow();
    }
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    updateItems(newItems) {
      this.items = newItems.filter(item => this.user && item.companyID === this.user.companyID);
      this.totalRows = this.items.length;
    },
    getAllClients(force) {
      clientAPIs
        .getAllClients(force)
        .then(response => {
          this.updateItems(response.data);
          this.lastUpdate = response.lastUpdate;
        })
        .catch(error => {
          // Request failed.
          console.log('error', error);
        });
    },
    isAlreadyAssigned: function(client) {
      const clientHandledBy = client.handledBy;

      return this.user && clientHandledBy && clientHandledBy.includes(this.user.id);
    },
    assignClient: function(client, shouldAssign) {
      var clientHandledBy = client.handledBy;
      if (!clientHandledBy) {
        clientHandledBy = [];
      }

      if (shouldAssign) {
        // Assign ad strategist to this client
        clientHandledBy.push(this.user.id);
      } else {
        // Remove ad strategist from this client
        clientHandledBy = clientHandledBy.filter(userID => userID !== this.user.id);
      }

      // Update handledBy for client
      const updatingClient = {
        id: client.id,
        handledBy: clientHandledBy
      };

      // Submit to server
      const clientData = this.buildFormData(updatingClient)
      clientAPIs
        .editClient(clientData, client.id)
        .then(response => {
          // Update items to reflect on the client table
          this.getAllClients(true);
        })
        .catch(error => {
          // Request failed.
          console.error(error);
        });
    },
    buildFormData(clientData) {
      let formData = new FormData();
      let client = Object.assign({}, clientData);
      formData.append('client', JSON.stringify(client));
      return formData;
    }
  },
  mounted() {
    this.getAllClients(false);
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// AssignUserToClientModal.vue?926d1498